import React from 'react';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
const Modal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  children,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={'fixed top-0 left-0 right-0 bottom-0 bg-black-main/80 overflow-scroll'}>
      <div className="absolute w-full sm:w-4/5 left-[50%] px-3 sm:px-0 py-3 sm:py-[40px] -translate-x-[50%]">
        <div className="relative min-h-[500px] bg-white px-5 sm:px-[80px] py-5 sm:py-[50px]">
          <button
            onClick={onClose}
            className={'absolute top-[15px] sm:top-[30px] right-[15px] sm:right-[50px]'}
          >
            <CloseOutlined color={'#999999'} className={'text-[20px]'} />
          </button>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
